import PropTypes from 'prop-types'
import { Warning } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const EscalationsWarning = ({ onClick }) => {
  const { t } = useTranslation(['on-call-schedule'])

  return (
    <div className="on-call-schedule__escalations-warning">
      <div className="on-call-schedule__escalations-warning-icon">
        <Warning size={24} />
      </div>
      <div className="on-call-schedule__escalations-warning-content">
        <h5 className="on-call-schedule__escalations-warning-title">
          {t('on-call-schedule:escalationsWarning.title')}
        </h5>
        <p className="on-call-schedule__escalations-warning-text">
          {t('on-call-schedule:escalationsWarning.description')}
        </p>
        <button className="button button-primary" onClick={onClick}>
          {t('on-call-schedule:escalationsWarning.button')}
        </button>
      </div>
    </div>
  )
}

EscalationsWarning.propTypes = {
  onClick: PropTypes.func,
}

export default EscalationsWarning
